import React from 'react';

import { Tag } from '@soluto-design/react';
import useEmblaCarousel from 'embla-carousel-react';
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures';
import cls from '@soluto-design/styles/cls';

export interface BlockGlossaryBarProps {
    uppercase?: boolean;
    tags?: {
        label: string;
        active?: boolean;
        disabled?: boolean;
        href?: boolean;
    }[];
    onClick?: (category: {
        label: string;
        active?: boolean;
        disabled?: boolean;
    }) => void;
    isPinned?: boolean;
}

export default function BlockGlossaryBar({
    uppercase,
    tags = [],
    onClick,
    isPinned = false,
}: BlockGlossaryBarProps) {
    const [emblaRef, emblaApi] = useEmblaCarousel({ dragFree: true }, [
        WheelGesturesPlugin({}),
    ]);

    return (
        <div
            className={cls(
                'pl-margin overflow-hidden transition',
                isPinned ? 'bg-background-tertiary' : 'bg-background-primary',
            )}
            ref={emblaRef}>
            {tags?.length > 0 && (
                <div className={cls('flex gap-16 py-16 [&>button]:min-w-80')}>
                    {tags.map((category) => {
                        const {
                            label,
                            active = false,
                            disabled = false,
                            href,
                        } = category;
                        return (
                            <Tag
                                key={`tag-${label}`}
                                variant="filter"
                                active={active}
                                className={cls(
                                    !!uppercase && 'uppercase',
                                    'select-none whitespace-nowrap',
                                    !!href && disabled && 'disabled',
                                )}
                                {...(href ? { href } : { disabled })}
                                onClick={(ev) => {
                                    if (typeof onClick === 'function') {
                                        ev?.preventDefault();
                                        onClick(category);
                                    }
                                }}>
                                {label}
                            </Tag>
                        );
                    })}
                </div>
            )}
        </div>
    );
}
